import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import HeadOfficeTab from "examples/Tabs/HeadOfficeTab_2";

function HeadOffice() {
  return (
    <DashboardLayout>
      <HeadOfficeTab />
    </DashboardLayout>
  );
}

export default HeadOffice;
